"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon } from "@mui/material";
type IconProps = {
  className?: string;
  isEditorMode?: boolean;
  iconName: string;
  iconColor?: string;
  [key: string]: any;
};
const DEFAULT_MUI_ICON_SIZE = 24;
const MuiIcon = t0 => {
  const $ = _c(18);
  let className;
  let iconName;
  let isEditorMode;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      isEditorMode,
      iconName,
      iconColor: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = iconName;
    $[3] = isEditorMode;
    $[4] = rest;
    $[5] = t1;
  } else {
    className = $[1];
    iconName = $[2];
    isEditorMode = $[3];
    rest = $[4];
    t1 = $[5];
  }
  const iconColor = t1 === undefined ? "main" : t1;
  if (isEditorMode && !iconName) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <b>Icon</b>;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <b>Icon</b>;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== className || $[9] !== rest) {
      t4 = <div className={className} {...rest}>Add new {t2} entry or bind existing {t3} entry</div>;
      $[8] = className;
      $[9] = rest;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  if (!isEditorMode && !iconName) {
    return null;
  }
  const t2 = iconColor || "inherit";
  let t3;
  if ($[11] !== t2) {
    t3 = {
      "&.MuiIcon-root": {
        fontSize: `${DEFAULT_MUI_ICON_SIZE}px`,
        color: t2,
        fontFamily: "Material Icons Outlined"
      }
    };
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const t4 = `material-icons-outlined ${className}`;
  let t5;
  if ($[13] !== iconName || $[14] !== rest || $[15] !== t3 || $[16] !== t4) {
    t5 = <Icon sx={t3} className={t4} data-testid="mui-icon" {...rest}>{iconName}</Icon>;
    $[13] = iconName;
    $[14] = rest;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default MuiIcon;